// WP-A · ID upload to Firebase Storage. Guests upload a photo of their ID at
// reservation time. The object lands under ids/<uid>/<timestamp>-<name> on the
// default Firebase Storage bucket (secured by storage.rules). We return the
// FULL gs:// URI so the reservation doc's id_doc_path is unambiguous and WP-B
// records id_doc_link verbatim (no bucket-derivation mismatch). The brain purges
// the object at checkout+14d (R-E) using this path. See HUMAN_INTERVENTION Q-A2
// for the dedicated onebeachbot-guest-ids bucket note.
import { ref, uploadBytes, getBlob } from "firebase/storage";
import { storage } from "../firebase.js";
import { ensureAnon } from "../firebase.js";
import { firebaseConfig } from "../config.js";

export async function uploadIdDoc(file) {
  const user = await ensureAnon();
  const uid = user.uid;
  const safeName = (file.name || "id").replace(/[^a-zA-Z0-9._-]/g, "_");
  const objectPath = `ids/${uid}/${Date.now()}-${safeName}`;
  const r = ref(storage, objectPath);
  await uploadBytes(r, file, { contentType: file.type || "application/octet-stream" });
  // Full gs:// URI to the default bucket — the contract WP-B consumes verbatim.
  return `gs://${firebaseConfig.storageBucket}/${objectPath}`;
}

// Read the uploaded bytes back (used only in dev/tests; denied in prod by rules).
export async function readIdDoc(gsUri) {
  const path = gsUri.replace(/^gs:\/\/[^/]+\//, "");
  const blob = await getBlob(ref(storage, path));
  return blob;
}
